import { useMemo, useContext } from 'react';

import { LocaleContext } from 'context/LocaleContext';

const GanttChartLinesDays = ({ chartDuration, chartStart, scaleItemWidth }) => {
    const localeCtx = useContext(LocaleContext);

    const lines = useMemo(() => {
        return new Array(chartDuration).fill(null);
    }, [chartDuration]);

    return (
        <div className="gantt-chart-lines">
            {
                lines.map((item, index) => (
                    <div
                        key={index}
                        className={'line' + (chartStart.clone().add(index + 1, 'days').weekday() === localeCtx?.weekStart ? ' major': '')}
                        style={{left: `${scaleItemWidth * (index + 1)}px`}}
                    />
                ))
            }
        </div>
    );
}

export default GanttChartLinesDays;
